
import Vue from 'vue';
import LineSkeleton from './atoms/LineSkeleton.vue';

export default Vue.extend({
  components: {
    LineSkeleton,
  },
  computed: {
    teacherPhoto() {
      return `${process.env.BASE_URL || ''}img/CollegeLogo.svg`;
    },
  },
});
